<div class="home-wrapper">
  <app-loading [progress]="progress" [showProgress]="true">
    @if (showTimeoutMessage) {
      <div class="error-message d-flex flex-column justify-content-center align-items-center">
        <p>It looks like something has gone wrong. Please click below to reload</p>
        <button mat-flat-button (click)="window.location.reload()">Reload</button>
      </div>
    }
  </app-loading>
</div>
